var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlphaTeamLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 72.5,
    fill: "#1A9EE8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 73,
    r: 54,
    fill: "#1A9EE8",
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 89,
    r: 10,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 89,
    r: 10,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 89,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 38L31 71H52.5L73 56.5L92 71H115L73 38Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 71L30.6911 70.6068C30.5235 70.7385 30.4578 70.962 30.5275 71.1634C30.5971 71.3649 30.7869 71.5 31 71.5V71ZM73 38L73.3089 37.6068C73.1276 37.4644 72.8724 37.4644 72.6911 37.6068L73 38ZM115 71V71.5C115.213 71.5 115.403 71.3649 115.473 71.1634C115.542 70.962 115.477 70.7385 115.309 70.6068L115 71ZM92 71L91.6967 71.3975C91.7838 71.464 91.8904 71.5 92 71.5V71ZM73 56.5L73.3033 56.1025C73.1295 55.9699 72.8897 55.9655 72.7113 56.0918L73 56.5ZM52.5 71V71.5C52.6034 71.5 52.7043 71.4679 52.7887 71.4082L52.5 71ZM31.3089 71.3932L73.3089 38.3932L72.6911 37.6068L30.6911 70.6068L31.3089 71.3932ZM72.6911 38.3932L114.691 71.3932L115.309 70.6068L73.3089 37.6068L72.6911 38.3932ZM115 70.5H92V71.5H115V70.5ZM92.3033 70.6025L73.3033 56.1025L72.6967 56.8975L91.6967 71.3975L92.3033 70.6025ZM72.7113 56.0918L52.2113 70.5918L52.7887 71.4082L73.2887 56.9082L72.7113 56.0918ZM52.5 70.5H31V71.5H52.5V70.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphaTeamLogo);
export default __webpack_public_path__ + "static/media/alpha_team_logo.3840ae58859cd8ce0dd9680b6c14bb76.svg";
export { ForwardRef as ReactComponent };